var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$attrs.text)?_c('span',{class:_vm.$attrs.type ? 'gray' : ''},[(!_vm.$attrs.type)?_c('img',{attrs:{"src":"/img/address.png","alt":""}}):_c('img',{attrs:{"src":"/img/address-gray.png","alt":""}}),_vm._v(_vm._s(_vm.$attrs.text)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }